import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../shared/custom-button/custom-button";
import AddIcon from "@mui/icons-material/Add";
import WelcomeCard from "../../componet/welcome-card";
import ClassesModal from "../../componet/classModal";
import { useSelector } from "react-redux";
import {
  createGroupService,
  deleteGroupService,
  getUserGroupService,
  updateGroupService,
} from "../../services/group-service";
import {
  faChalkboardTeacher,
  faAnglesRight,
  faGraduationCap,
  faClock,
  faTrophy,
  faBolt
} from '@fortawesome/free-solid-svg-icons';
import {
  getAllUserSubjectService,
} from "../../services/subject-service";
import {
  IconButton,
  Menu,
  MenuItem,
  Modal,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { RootState } from "../../redux/store/store";
import { SnackbarContext } from "../../config/hooks/use-toast";
import { classesLevel } from "../../mocks/education-level";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DashboardLayout from "../../shared/layout/DashboardLayout";
import { motion, AnimatePresence } from "framer-motion";
import { faTrashCan, faTriangleExclamation, faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

const Home: React.FC = () => {
  const role = useSelector(
    (state: RootState) => state?.user?.userData?.role.name,
  );
  const isStudent = role === "ROLE_STUDENT";
  const snackbarContext = useContext(SnackbarContext);
  const navigation = useNavigate();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [profileData, setProfileData] = useState<any[]>([]);
  const [subjects, setSubjects] = useState<any[]>([]);
  const [selectedProfile, setSelectedProfile] = useState<any | null>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openAlert, setOpenAlert] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentItem, setCurrentItem] = useState<any | null>(null);

  const unwrap = (res: any) => res?.data?.data ?? res?.data ?? res;
  
  useEffect(() => {
    if (isStudent) {
      getAllUserSubjectService()
        .then((res) => {
          const payload = unwrap(res) ?? [];
          setSubjects(payload);
        })
        .catch((e) => {
          console.log(e);
        });
      return;
    }

    getUserGroupService()
      .then((res) => {
        setProfileData(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [isStudent]);

  const handleOpenModal = (profile: any | null) => {
    setSelectedProfile(profile);
    setIsEdit(profile !== null);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedProfile(null);
    setIsEdit(false);
    setCurrentItem(null);
    setModalOpen(false);
  };

  const handleSave = (formData: any) => {
    if (isEdit && selectedProfile) {
      updateGroupService(selectedProfile.id, formData)
        .then(() => {
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Success",
              "Class modified successfully",
              "success",
            );
          }
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error updating group:", error);
        });
    } else {
      createGroupService(formData)
        .then(() => {
          if (snackbarContext) {
            snackbarContext.showMessage(
              "Success",
              "Class added successfully",
              "success",
            );
          }
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error creating group:", error);
        });
    }
  };

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>, item: any) => {
    setAnchorEl(event.currentTarget);
    setCurrentItem(item);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setCurrentItem(null);
  };

  const handleClickAlert = (profile: any) => {
    setSelectedProfile(profile);
    setOpenAlert(true);
    handleCloseMenu();
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
    setSelectedProfile(null);
  };

  const handleSubmitAlert = () => {
    deleteGroupService(selectedProfile.id)
      .then(() => {
        setOpenAlert(false);
        setSelectedProfile(null);
        if (snackbarContext) {
          snackbarContext.showMessage(
            "Success",
            "Class deleted successfully",
            "success",
          );
        }
        window.location.reload();
      })
      .catch((e) => {
        console.log(e);
      });
  };
  
  const getEducationLevelLabel = (value: string) => {
    const level = classesLevel.find((level) => level.value === value);
    return level ? level.label : value;
  };

  const handleSubjectClick = (item: any) => {
    if (item?.isClosed) {
      if (snackbarContext) {
        snackbarContext.showMessage(
          "Accès verrouillé",
          "Votre abonnement est expiré. Souscrivez à une offre pour rouvrir ce cours.",
          "info",
        );
      }
      navigation("/dashboard/offer-student");
      return;
    }
    navigation(`/subject-details?id=${item.id}`);
  };

  return (
    <DashboardLayout>
      <div className="flex flex-col items-center px-4 space-y-8 md:px-8">
        <div className="w-full flex flex-col gap-10">
          <WelcomeCard />
        </div>

             
        {isStudent ? (
          <div className="w-full pt-4 mb-10">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
              <div className="flex flex-col gap-2">
                <h2 className="text-4xl font-black text-title uppercase tracking-tight flex items-center gap-4">
                  <div className="w-4 h-12 bg-primary rounded-full"></div>
                  Parcourir vos sujets
                </h2>
                <p className="text-text/50 font-bold uppercase tracking-widest text-[10px] ml-8">Continuez votre progression dans vos cours favoris.</p>
              </div>
              <div className="flex items-center gap-3">
                <div className="px-6 py-3 bg-white border border-gray-100 rounded-[1.2rem] shadow-[0_15px_40px_rgba(0,0,0,0.03)] text-center">
                  <p className="text-[10px] font-bold text-text/40 uppercase tracking-widest mb-1">Total Matières</p>
                  <p className="text-2xl font-black text-primary">{subjects.length}</p>
                </div>
              </div>
            </div>

            {subjects.length === 0 ? (
              <div className="flex flex-col items-center justify-center w-full min-h-[400px] p-12 text-center bg-white border border-gray-100 shadow-[0_20px_50px_rgba(0,0,0,0.03)] rounded-[3rem] group">
                <div className="w-24 h-24 bg-primary/5 rounded-full flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500">
                  <FontAwesomeIcon icon={faChalkboardTeacher} className="text-4xl text-primary/40" />
                </div>
                <p className="mb-4 text-2xl font-black text-title tracking-tight">Aucun cours pour le moment</p>
                <p className="mb-10 text-text/60 max-w-md font-medium leading-relaxed">Abonnez-vous à une offre pour débloquer vos matières et commencer votre parcours d'excellence.</p>
                <button
                  onClick={() => navigation("/dashboard/offer-student")}
                  className="px-10 py-4 bg-primary text-white font-black rounded-2xl shadow-xl shadow-primary/20 hover:shadow-2xl hover:shadow-primary/30 hover:-translate-y-1 transition-all duration-300"
                >
                  Découvrir les offres
                </button>
              </div>
            ) : (
              <div className="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {subjects.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => handleSubjectClick(item)}
                    className={`group relative overflow-hidden bg-white rounded-[2.5rem] border border-gray-100 shadow-[0_20px_50px_rgba(0,0,0,0.02)] transition-all duration-500 hover:shadow-[0_30px_70px_rgba(0,0,0,0.08)] hover:-translate-y-2 cursor-pointer ${item.isClosed ? "opacity-90" : ""}`}
                  >
                    {/* Cover Image with Gradient Overlay */}
                    <div className="relative h-56 overflow-hidden">
                      <div
                        className="w-full h-full transition-all duration-700 bg-center bg-cover transform group-hover:scale-110"
                        style={{ backgroundImage: `url("${item.backgroundImageUrl}")` }}
                      ></div>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                      <div className="absolute top-5 left-5 z-20">
                        <span className="px-4 py-2 bg-[#09745f] shadow-xl shadow-black/20 rounded-xl text-[10px] font-black text-white border border-white/10 uppercase tracking-[0.2em]">
                          {item.level}
                        </span>
                      </div>
                      {item.isClosed && (
                        <div className="absolute inset-0 flex items-center justify-center bg-title/40 backdrop-blur-[2px]">
                          <div className="px-6 py-3 bg-red-500 text-white text-xs font-black rounded-full shadow-2xl border-2 border-white/20 uppercase tracking-widest animate-pulse">Souscription Expire</div>
                        </div>
                      )}

                      <div className="absolute bottom-5 left-5 flex items-center gap-3 p-2 rounded-2xl bg-black/30 backdrop-blur-md border border-white/10">
                        <div className="w-10 h-10 rounded-xl bg-primary border-2 border-white/30 flex items-center justify-center shadow-lg overflow-hidden transition-transform duration-300 group-hover:rotate-6">
                          <FontAwesomeIcon icon={faChalkboardTeacher} className="text-white text-sm" />
                        </div>
                        <div className="flex flex-col">
                          <span className="text-[10px] font-bold text-white/70 uppercase leading-none">Professeur</span>
                          <span className="text-sm font-black text-white leading-tight truncate max-w-[150px]">{item.superTeacherFullName}</span>
                        </div>
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="p-8 pb-4">
                      <h3 className="text-xl font-black text-title mb-4 leading-tight min-h-[3rem] line-clamp-2 group-hover:text-primary transition-colors duration-300">
                        {item.speciality}
                      </h3>
                      
                      <div className="flex items-center justify-between pt-4 border-t border-gray-50">
                        <div className="flex items-center gap-1.5 text-text/60 font-bold text-xs uppercase tracking-wider">
                          <div className="w-1.5 h-1.5 bg-primary rounded-full"></div>
                          <span>Leçons & Ressources</span>
                        </div>
                        <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center text-gray-400 group-hover:bg-primary group-hover:text-white transition-all duration-300">
                          <FontAwesomeIcon icon={faAnglesRight} className="text-[10px]" />
                        </div>
                      </div>
                    </div>

                    {/* Action Overlay */}
                    <div className={`mt-2 ${item.isClosed ? "px-8 pb-8" : "px-8 pb-8 transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300"}`}>
                      <div className={`w-full py-4 rounded-2xl font-black text-sm uppercase tracking-widest text-center shadow-xl transition-all duration-300 ${item.isClosed ? "bg-gray-100 text-text/40 border border-gray-200" : "bg-primary text-white shadow-primary/20 hover:shadow-primary/30"}`}>
                        {item.isClosed ? "Souscrire" : "Consulter Détails"}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="w-full pt-4 mb-10">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6 px-4">
              <div className="flex flex-col gap-2">
                <h2 className="text-4xl font-black text-title uppercase tracking-tight flex items-center gap-4">
                  <div className="w-4 h-12 bg-primary rounded-full"></div>
                  Gestion des Classes
                </h2>
                <p className="text-text/50 font-bold uppercase tracking-widest text-[10px] ml-8">Administrez vos programmes et suivez vos élèves.</p>
              </div>
            </div>
            
            <div className="grid w-full grid-cols-1 gap-8 px-4 sm:grid-cols-2 lg:grid-cols-3">
              {profileData.map((item) => (
                <div
                  key={item.id}
                  onClick={() => navigation(`/subject/${item.id}`)}
                  className="group relative overflow-hidden bg-white rounded-[2.5rem] border border-gray-100 shadow-[0_20px_50px_rgba(0,0,0,0.02)] transition-all duration-700 hover:shadow-[0_40px_90px_rgba(0,0,0,0.12)] hover:-translate-y-3 cursor-pointer flex flex-col h-full"
                >
                  <div className="relative h-64 overflow-hidden">
                    <div
                      className="w-full h-full transition-all duration-1000 bg-center bg-cover transform group-hover:scale-110"
                      style={{ backgroundImage: `url("${item.backgroundImageUrl}")` }}
                    ></div>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent"></div>
                    
                    {(role === "ROLE_ADMIN" || role === "ROLE_SUPER_TEACHER") && (
                      <div className="absolute top-4 right-4 z-20">
                        <IconButton 
                          onClick={(event) => {
                            event.stopPropagation();
                            handleClickMenu(event, item);
                          }} 
                          className="!bg-white/20 !backdrop-blur-md !p-2 !rounded-xl shadow-lg hover:!bg-white group/btn transition-all duration-300"
                        >
                          <MoreVertIcon className="text-white group-hover/btn:text-title" />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl) && currentItem === item}
                          onClose={handleCloseMenu}
                          PaperProps={{
                            sx: { borderRadius: '24px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)', minWidth: '180px', p: 1, border: '1px solid rgba(0,0,0,0.05)' }
                          }}
                        >
                          <MenuItem onClick={(e) => { e.stopPropagation(); handleOpenModal(item); handleCloseMenu(); }} className="!rounded-2xl !py-3 !font-black !text-[11px] !uppercase !tracking-widest !text-title hover:!bg-gray-50">Modifier</MenuItem>
                          <MenuItem onClick={(e) => { e.stopPropagation(); handleClickAlert(item); }} className="!rounded-2xl !py-3 !font-black !text-[11px] !uppercase !tracking-widest !text-red-500 hover:!bg-red-50">Supprimer</MenuItem>
                        </Menu>
                      </div>
                    )}
                    
                    <div className="absolute bottom-6 left-6 right-12">
                        <div className="flex items-center gap-4 p-3 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/10">
                          <div className="w-12 h-12 rounded-xl bg-primary border-2 border-white/20 flex items-center justify-center shadow-2xl overflow-hidden group-hover:rotate-6 transition-transform duration-500">
                             <FontAwesomeIcon icon={faChalkboardTeacher} className="text-white text-lg" />
                          </div>
                          <div className="flex flex-col">
                            <p className="text-[9px] font-bold text-white/50 uppercase tracking-widest leading-none mb-1">Responsable</p>
                            <p className="text-sm font-black text-white leading-tight truncate">{item.superTeacherFullName}</p>
                          </div>
                        </div>
                    </div>
                  </div>

                  <div className="p-8 flex flex-col flex-1">
                    <h3 className="text-2xl font-black text-title mb-10 line-clamp-2 group-hover:text-primary transition-colors duration-500 tracking-tight min-h-[4rem] flex items-center">{item.title}</h3>
                    <div className="flex items-center gap-3 mb-8">
                       <span className="px-4 py-1.5 bg-primary/5 text-primary text-[10px] font-black uppercase tracking-[0.2em] rounded-xl border border-primary/10">
                          {getEducationLevelLabel(item.educationLevel)}
                       </span>
                    </div>
                    <div className="w-full py-5 bg-[#05322B] text-white font-black text-[11px] uppercase tracking-[0.3em] text-center rounded-[1.5rem] transition-all duration-500 hover:bg-primary shadow-2xl shadow-black/20 hover:-translate-y-1 mt-auto">
                       Gérer la classe
                    </div>
                  </div>
                </div>
              ))}
              
              {(role === "ROLE_ADMIN" || role === "ROLE_SUPER_TEACHER") && (
                <div
                  onClick={() => handleOpenModal(null)}
                  className="flex flex-col items-center justify-center p-12 border-2 border-dashed border-gray-200 rounded-[3rem] cursor-pointer bg-gray-50/30 hover:bg-white hover:border-primary/50 hover:shadow-2xl transition-all duration-700 group min-h-[500px]"
                >
                  <div className="w-20 h-20 bg-white shadow-[0_20px_40px_rgba(0,0,0,0.05)] rounded-3xl flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-primary group-hover:text-white transition-all duration-500 border border-gray-50">
                    <AddIcon sx={{ fontSize: 40 }} />
                  </div>
                  <p className="text-title font-black uppercase tracking-[0.3em] text-[11px] text-center">Créer une<br/>nouvelle classe</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <ClassesModal
        open={modalOpen}
        onClose={handleCloseModal}
        modalTitle={isEdit ? "Modifier la Classe" : "Ajouter une Classe"}
        buttonText={isEdit ? "Modifier" : "Ajouter"}
        handleActionClick={handleSave}
        initialData={selectedProfile}
      />

      <AnimatePresence>
        {openAlert && (
          <Modal
            open={openAlert}
            onClose={handleCloseAlert}
            className="flex items-center justify-center p-4 backdrop-blur-xl bg-title/40"
            closeAfterTransition
          >
            <motion.div 
              className="w-full max-w-[450px] bg-white rounded-[3rem] p-10 shadow-3xl text-center outline-none border border-white/20"
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
            >
              <div className="w-24 h-24 rounded-[2.5rem] bg-rose-50 text-rose-500 flex items-center justify-center text-4xl mx-auto mb-8 border border-rose-100 shadow-sm relative">
                <div className="absolute inset-0 bg-rose-400/20 rounded-[2.5rem] animate-ping opacity-50"></div>
                <FontAwesomeIcon icon={faTrashCan} className="relative z-10" />
              </div>
              
              <h3 className="text-2xl font-black text-title uppercase tracking-tight mb-4">
                Confirmer la <span className="text-rose-500">Suppression</span>
              </h3>
              
              <p className="text-sm font-medium text-text/60 leading-relaxed mb-10 px-4">
                Êtes-vous sûr de vouloir supprimer la classe <span className="text-[#05322B] font-black">{selectedProfile?.title}</span> ? Cette action est irréversible.
              </p>

              <div className="flex gap-4">
                <button
                  className="flex-1 h-16 bg-slate-50 text-text/40 font-black text-[11px] uppercase tracking-widest rounded-2xl hover:bg-slate-100 transition-all duration-300 outline-none"
                  onClick={handleCloseAlert}
                >
                  Annuler
                </button>
                <button
                  className="flex-1 h-16 bg-rose-500 text-white font-black text-[11px] uppercase tracking-widest rounded-2xl shadow-xl shadow-rose-500/20 hover:bg-rose-600 hover:-translate-y-1 transition-all duration-300 outline-none"
                  onClick={handleSubmitAlert}
                >
                  Supprimer
                </button>
              </div>
            </motion.div>
          </Modal>
        )}
      </AnimatePresence>
    </DashboardLayout>
  );
};

export default Home;
